import { useFetch } from "@hyper-fetch/react";
import { createFileRoute } from "@tanstack/react-router";

import { sdk } from "@/api/sdk";
import { ArchiveList } from "@/features/shop/modules/archive/archive-list";
import { requireSelling } from "@/features/shop/modules/offer-shell/require-selling";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(private)/offer/archive/")({
  beforeLoad: requireSelling,
  loader: () => ({ crumb: m.offer_tab_archive() }),
  component: ArchivePage,
});

function ArchivePage() {
  const { data: settings } = useFetch(sdk.booking.settings.$get);
  return <ArchiveList currency={settings?.currency ?? "PLN"} />;
}
